import { Component, EventEmitter, input, Input, Output } from '@angular/core';

import { IColumn } from '@shared/ui-components/au-table-layout/utils/interfaces';
import { TABLE_ACTIONS } from '@shared/ui-components/au-table-layout/utils/enums';
import { SelectionModel } from '@angular/cdk/collections';
import { AuTableComponent } from './au-table/au-table.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CmmsEntities } from '@app/domain/types';

@Component({
	selector: 'au-table-layout',
	templateUrl: './au-table-layout.component.html',
	styleUrls: ['./au-table-layout.component.scss'],
	imports: [AuTableComponent, MatProgressSpinner],
})
export class AuTableLayoutComponent {
	teamView = input<boolean>(false);
	openedFromActionCenter = input<boolean>(false);
	@Input() isLoading: boolean;
	@Input() filteredData: CmmsEntities[];
	@Input() actions: TABLE_ACTIONS[] = [];
	@Input() usePlaceholderForAvatar = false;
	@Input() isClickableRow = true;
	@Input() numOfStickyColumns: number = 1;

	// main options
	@Input() data: CmmsEntities[];
	@Input() displayedColumns: IColumn[] = [];
	@Input() tableSelection = false;
	@Input() tableSelectedData: SelectionModel<CmmsEntities>;
	// end main options

	// checkbox output
	@Output() bulkSelection = new EventEmitter<{
		data: CmmsEntities[];
		isAllSelected: boolean;
	}>();
	@Output() rowCheckboxSelect = new EventEmitter<CmmsEntities>();
	@Output() rowCheckboxesSelect = new EventEmitter<CmmsEntities[]>();
	@Output() selectColumn = new EventEmitter<CmmsEntities>();
	@Output() delete: EventEmitter<CmmsEntities> = new EventEmitter<CmmsEntities>();
	@Output() edit: EventEmitter<CmmsEntities> = new EventEmitter<CmmsEntities>();
	@Output() reload: EventEmitter<CmmsEntities> = new EventEmitter<CmmsEntities>();
	@Output() cmmsDelete: EventEmitter<{ data: CmmsEntities }> = new EventEmitter<{
		data: CmmsEntities;
	}>();
	@Output() tableRowClick: EventEmitter<CmmsEntities> = new EventEmitter<CmmsEntities>();
}
